exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".li-pb{\r\n    padding-bottom: 5px;\r\n}\r\nli:hover{\r\n    background-color:azure;\r\n    cursor: pointer;\r\n}\r\nul{\r\n    background: white;\r\n    padding: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/leaves/leaves.component.css
// module id = ../../../../../src/app/hrms/leaves/leaves.component.css
// module chunks = main